import React from "react";
import { Navigate, Outlet } from "react-router";
import type { Role } from "../../providers/AuthProvider";
import { useAuth } from "../../providers/AuthProvider";

export function RequireRole({ roles, children }: { roles: Role[]; children?: React.ReactNode }) {
  const { user, isLoading } = useAuth();
  if (isLoading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (!roles.includes(user.role)) return <Navigate to="/" replace />;
  if (children) return <>{children}</>;
  return <Outlet />;
}

